<template>
  <div>
    <sub-head></sub-head>
    <div class="page_padding">
      <bread-crumb :path="$route"></bread-crumb>
    </div>
    <div class="">
      <div class="title marginT">
        <span class="fontBold font41">설치 사례</span>
      </div>
      <div class="page_padding">
        <div class="reference-info-wrapper">
          <div class="reference-info">
            <div class="backgroun-color">
              <span>전국 다수 보급 중</span>
              <!-- <span class="font30 fontBold">{{ referenceInfo.length }}</span> -->
            </div>
            <img src="@/assets/source/images/Installation_map.jpg" alt="지도" />
          </div>
          <div class="reference-info-list">
            <div
              v-for="(item, index) in referenceInfo"
              :key="index"
              class="item"
            >
              <span class="fontBold">{{ item.site }}</span>
              <!-- <image-component
                class="refer-img"
                :is_jpg="false"
                path=""
                :name="isMobile ? 'm_' + item.imgSrc : item.imgSrc"
              ></image-component> -->
              <!-- <img :src="getImgSrc(item.imgSrc)" /> -->
              <img :src="getImgSrc(item.imgSrc)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subHead from "../../components/sub_head.vue";
import reference from "@/assets/source/json/reference_0605.json";

import BreadCrumb from "../../components/BreadCrumb.vue";
// import ImageComponent from "../../components/imageComponent.vue";

export default {
  components: {subHead, BreadCrumb},
  data() {
    return {
      // content: jsonContents,
      referenceInfo: reference,
      show: false,
      is_all: "",
      button_value: "더보기",
      isMobile: false,
    };
  },

  mounted() {
    this.checkBrowserWidth();
    window.addEventListener("resize", this.checkBrowserWidth);
  },
  methods: {
    checkBrowserWidth() {
      // if (window.innerWidth <= 550) {
      //   this.isMobile = true;
      // } else {
      //   this.isMobile = false;
      // }
    },
    getImgSrc(src) {
      const actualSrc = src ? src : "happytable-default";
      const prefix = this.isMobile ? "m_" : "";

      // if (window.innerWidth <= 550) {
      //   src = "m_" + src;
      // }
      let images = require.context(
        "../../assets/source/images/",
        false,
        /\.png$/
      );
      return images("./" + prefix + actualSrc + ".png");
    },
  },
};
</script>

<style scoped>
.reference-info-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-bottom: 8rem;
}

.reference-info-list,
.reference-info {
  border: 1px solid #dddd;
  width: 30rem;
  /* width: 100%; */
  flex-direction: column;
  height: 50rem;
  overflow: scroll;
  overflow-x: hidden;
  box-sizing: border-box;
}
.reference-info-list {
}
.reference-info {
  overflow: hidden;
  width: 30rem;
  padding: 19.2px;
}

.reference-info img {
  padding: 5rem 0;
  width: 100%;
}

.reference-info-list .item {
  display: flex;
  align-items: center;
  padding: 0 1rem;
  justify-content: space-between;
  text-align: left;
  border-bottom: 2px solid #f3f3f3;
}

.backgroun-color {
  background-color: #ff5230;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
}

.backgroun-color span {
  color: #fff;
}

.reference .d-flex {
  width: 49%;
  justify-content: center;
  padding: 1rem 0;
}
.reference img {
  border-radius: 20px;
}
.imgWrap {
  width: 100%;
}
.imgWrap img {
  width: 100%;
}
.d-flex div {
  width: 100%;
}
.margin-right {
  margin-right: auto;
}
.margin-left {
  margin-left: auto;
}
.header {
  border-bottom: 1px solid #d1d1d1;
}
.btn {
  color: black !important;
  border: none;
  text-decoration: none;
  background-color: #e3e3e3;
  outline: none;
  margin: 0 auto;
  width: 100%;
  height: 100px;
}
.btn:hover {
  background-color: #e3e3e3;
}
.headlineWrap {
  padding-bottom: 0.2rem;
}
.contentWrap {
  color: #606060;
}
.marginT.reference-info-list {
  margin-top: 0;
}
.reference-info {
  margin-bottom: 2rem;
}
</style>
